module.exports = __webpack_public_path__ + "img/VTC logomark colour.53eff849.jpg";